import { useEnterpriseIdentity } from '@/components/common/contexts/enterprise-identity-context'
import kolrBrandLogoSrc from '@/public/assets/kolr-logo/kolr-logo-horizontal.png'
import kolrAppLogoSrc from '@/public/assets/kolr-logo/kolr-logo-icon.png'

export const DEFAULT_BRAND_NAME = 'Kolr'

type UseBrandInfo = () => {
  brandName: string
  brandLogoSrc: string
  appLogoSrc: string
  hasEnterpriseIdentity: boolean
}

const useBrandInfo: UseBrandInfo = () => {
  const enterpriseIdentity = useEnterpriseIdentity()

  return {
    brandName: enterpriseIdentity?.name ?? DEFAULT_BRAND_NAME,
    brandLogoSrc: enterpriseIdentity?.brand_logo_url ?? kolrBrandLogoSrc,
    appLogoSrc: enterpriseIdentity?.app_logo_url ?? kolrAppLogoSrc,
    hasEnterpriseIdentity: !!enterpriseIdentity,
  }
}

export default useBrandInfo
